enum ReadyToDriveStatus {
    NOT_READY = 'NOT_READY',
    READY_TO_DRIVE = 'READY_TO_DRIVE',
    NO_SIGNAL = 'NO_SIGNAL',
}

export default ReadyToDriveStatus;
